import { graphql } from 'gatsby'
import React from 'react'

import EmbedSpotify from './embedSpotify'

type Props = {
  url: string | null | undefined
}
const Embed: React.FC<Props> = ({ url }) => {
  if (url && url.includes('open.spotify.com')) {
    return <EmbedSpotify url={url} />
  }
  return <></>
}

export default Embed

export const query = graphql`
  fragment EmbedInline on DatoCmsEmbed {
    __typename
    id: originalId
    url
  }
`
